import { Modal } from 'almanac-ui/Modal'
import { Header } from './components/Header/Header'
import { PostPreviewModalContent } from './PostPreviewModalContent'
import { PostPreviewProps } from 'components/PostPreviewModal/Types'

export const PostPreviewModalV2 = (props: PostPreviewProps) => (
  <Modal.Root size="md">
    <Header />
    <Modal.Content>
      <PostPreviewModalContent {...props} />
    </Modal.Content>
  </Modal.Root>
)
